import api from "../../api/v1";

export const state = () => ({
    count: 0,
    items: [],
    paginator: {
        links: [],
        first_page_url: null,
        last_page_url: null,
        prev_page_url: null,
        next_page_url: null,
        from: null,
        to: null,
        total: null,
    },
    params: {
        status: 'Complect',
        page: 1,
        per_page: 20,
        site_id: null,
        sort: 'buchungs.id',
        direction: 'desc',
        search: null,
        date_from: null,
        date_to: null,
    }
})

export const actions = {
    count({commit, state}) {
        return api.basket_item.count({status: state.params.status}).then(
            response => {
                commit('updateCount', response.count)
                return Promise.resolve(response)
            }, error => {
                return Promise.reject(error)
            }
        )
    },

    items({commit}, data) {
        return api.basket_item.items(data).then(
            response => {
                commit('updateItems', response)
                return Promise.resolve(response)
            }, error => {
                return Promise.reject(error)
            }
        )
    },

    itemUpdate({commit}, data) {
        return this.$api.basketItems.update_buchung(data).then(
            response => {
                commit('updateItem', data)
                return Promise.resolve(response)
            }, error => {
                return Promise.reject(error)
            }
        )
    },

    subItemUpdate({commit}, data) {
        return this.$api.orders.update_item(data.id, data.fields).then(
            response => {
                commit('updateSubItem', data)
                return Promise.resolve(response)
            }, error => {
                return Promise.reject(error)
            }
        )
    },

    setSearch({commit}, value) {
        commit('updateSearch', value)
    },

    setSort({commit}, value) {
        commit('updateSort', value)
    },

    setPerPage({commit}, value) {
        commit('updatePerPage', value)
    },

    setPage({commit}, value) {
        commit('updatePage', value)
    },

    setSiteId({commit}, value){
        commit('updateSite', value)
    },

    setDateFrom({commit}, value){
        commit('updateDateFrom', value)
    },

    setDateTo({commit}, value){
        commit('updateDateTo', value)
    },
}

export const mutations = {
    updateItems(state, value) {
        state.items = value.data
        Object.keys(state.paginator).forEach(el => state.paginator[el] = value[el])
    },

    updateItem(state, data) {
        const item = state.items.find(el => el.id === data.id)
        Object.keys(data).forEach(el => {
            item[el] = data[el]
            if (el !== 'id') item.items.map(e => e[el] = data[el])
        })
    },

    updateSubItem(state, data) {
        const item = state.items.find(el => el.number === data.fields.number)
        const subitem = item.items.find(el => el.id === data.id)
        console.log(subitem)
        Object.keys(data.fields).forEach(el =>subitem[el] = data.fields[el])
    },

    updateCount(state, value) {
        return state.count = value
    },

    updateSort(state, value) {
        if (value === state.params.sort) state.params.direction = state.params.direction === 'asc' ? 'desc' : 'asc';
        else state.params.sort = value;
    },

    updateSearch(state, value) {
        state.params.search = value;
    },

    updatePerPage(state, value) {
        state.params.per_page = value;
    },

    updatePage(state, value) {
        state.params.page = value;
    },

    updateSite(state, value) {
        state.params.site_id = value;
    },

    updateDateFrom(state, value) {
        state.params.date_from = value;
    },

    updateDateTo(state, value) {
        state.params.date_to = value;
    },
}

export const getters = {
    counter(state) {
        return state.count
    },

    items(state) {
        return state.items
    },

    paginator(state) {
        return state.paginator
    },

    params(state) {
        return state.params
    }
}